import { Button, Flex } from "@chakra-ui/react"
import React from "react"
import { useBrandedTranslation } from "../../../common/hooks/useBrandedTranslation"
import { CEnter } from "../../shared/Icons"

type Props = {
  handleSubmit: React.FormEventHandler
  preventBlur: React.MouseEventHandler
}

const SuggestionsFooterLink = ({ preventBlur, handleSubmit }: Props) => {
  const { t } = useBrandedTranslation()
  return (
    <Flex as="section" justifyContent="flex-end" mr="2">
      <Button
        aria-label="search"
        onMouseDown={preventBlur}
        onClick={handleSubmit}
        rightIcon={<CEnter boxSize="3" mb="0.5" />}
        variant="secondary"
      >
        {t("suggest-search-link")}
      </Button>
    </Flex>
  )
}

export default SuggestionsFooterLink
